import BaseChartOptions from "../../../utils/BaseChart/BaseChartOptions";

class BarChartOptions extends BaseChartOptions{
    constructor(data: Array<any>, barIDs: string[]) {
        super(data);
        this.setChildren(
            barIDs.map(id => ({ id, type: "interval"})))
    }
}

export default BarChartOptions;